import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles'

import find from 'lodash/find'
import remove from 'lodash/remove'

import numeralHinstance from './../../../../libs/numeral'

import DeailtRow from './DetailRow'
import { DataTypeDataKeyOrder, ColorPalette } from './../../../../libs/DataUtilities'
import { CountrySourcesIcons } from './../../../../libs/CountrySources'

import './TableContent.css'

const styles = theme => ({
    responsiveTableWrap: {
        overflowX: 'scroll'
    },
    denseRow: {
        height: 24
    },
    baseCell: {
        paddingRight: 4,
        paddingLeft: 4,
        fontSize: 10
    },
    headerCellImage: {
        width: 20,
        marginBottom: -8
    },
    istatCell: { color: ColorPalette.istat },
    taCell: { color: ColorPalette.ta },
    airbnbCell: { color: ColorPalette.airbnb }
});

class TableContent extends Component {

    /* Methods */
    getRegionRowStyle = (region) => {

        if(this.props.currentSelection.region) {
            if(this.props.currentSelection.region == region) return { opacity: 1 }
            else return { opacity: 0.5 }
        }
        return { opacity: 1 }
    }

    /* Lifecycle */
     
    render() {

        const { classes, dataType, data } = this.props
        const { rowHover } = this.props

        const filteredData = data
        const allData = remove(filteredData, (e) => {
            return e.region == 'all'
        })[0]

        let headerCells = []
        const bodyRows = filteredData.map((data, index) => {

            const { region, data_type } = data

            return (
                <TableRow className={classes.denseRow} 
                          style={this.getRegionRowStyle(region)}
                          key={index}
                          onMouseEnter={() => rowHover(region, 'enter')}
                          onMouseLeave={() => rowHover(region, 'leave')}
                          onTouchStart={() => rowHover(region, 'enter')}>
                    <TableCell component="th" scope="row">
                        <strong>{this.context.t(`regions.${region}`)}</strong>
                    </TableCell>

                    {
                        DataTypeDataKeyOrder[data_type].map((k, i) => {
                            
                            const innerData = find(data.data, {key: k})

                            if(innerData) {
                                /* Populate headers only for present inner data */
                                if(!find(headerCells, {key: `headerCell_${i}`})) {
                                    headerCells.push(
                                        <TableCell key={`headerCell_${i}`} numeric>
                                            <img className={classes.headerCellImage} src={CountrySourcesIcons[k]}/>
                                        </TableCell>
                                    )
                                }

                                const { key, value, measure_unit, source } = innerData
                                return (
                                    <TableCell key={`bodyCell_${i}`} className={[classes.baseCell, classes[`${source}Cell`]].join(' ')} numeric>
                                        {value ? value.toLocaleString('it') : '-'}{/*value ? numeralHinstance(value).format('0,0[.]0') : '-'*/}{measure_unit}
                                    </TableCell>
                                )
                            }
                        })
                    }
                </TableRow>
            );
        })

        return (
            <div className="pages-shared-data-visualizer-table-content">
                <DeailtRow data={allData}/>
                
                <div className={classes.responsiveTableWrap}>

                    <Table className={classes.table} padding="none">
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                { headerCells }

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {bodyRows}
                        </TableBody>
                    </Table>

                </div>

            </div>       
        )
    }
}

TableContent.contextTypes = {
    t: PropTypes.func
}

export default withStyles(styles)(TableContent)


// WEBPACK FOOTER //
// ./src/components/pages/shared/data_visualizer/TableContent.js